/**
 * App Version Management Models
 * Essential logic for version comparison
 */

export interface ReleaseNoteTranslation {
  title?: string;
  content?: string;
}

export interface ReleaseNote {
  version?: string;
  image_url?: string;
  translations?: Record<string, ReleaseNoteTranslation>;
}

/**
 * Compare two semantic versions
 * Returns: -1 if v1 < v2, 0 if v1 === v2, 1 if v1 > v2
 */
export function compareVersions(v1: string, v2: string): number {
    const parseVersion = (version: string): number[] => {
        return version.split('.').map(num => parseInt(num, 10) || 0);
    };

    const v1Parts = parseVersion(v1);
    const v2Parts = parseVersion(v2);

    const maxLength = Math.max(v1Parts.length, v2Parts.length);

    for (let i = 0; i < maxLength; i++) {
        const v1Part = v1Parts[i] || 0;
        const v2Part = v2Parts[i] || 0;

        if (v1Part < v2Part) return -1;
        if (v1Part > v2Part) return 1;
    }

    return 0;
}

/**
 * Check if current version meets minimum requirement
 */
export function isVersionCompatible(currentVersion: string, minimumVersion: string): boolean {
    return compareVersions(currentVersion, minimumVersion) >= 0;
}
